import React, { useContext, useState } from "react";
import styled from "styled-components";
import ProductCard from "../components/ProductCard";
import Breakpoints from "../components/styles/Breakpoints";
import { Colors } from "../components/styles/Colors";
import { Header2 } from "../components/typography";
import { getProductSubscriptionData } from "../utils/Prive";
import { addOneTimeItem, addSubscriptionItem } from "../utils/StoreActions";
import { store } from "../utils/StoreContext";

const Wrapper = styled.div`
  padding: 64px 32px;

  background: ${Colors.cream2};

  ${Header2} {
    text-align: center;
    margin: 24px auto 40px;
    max-width: 660px;
  }

  @media ${Breakpoints.tablet} {
    padding: 128px 64px;
  }
`;

const SliderAndGrid = styled.div`
  width: 100%;

  > a {
    margin: 18px 0;
    width: 100%;
  }

  @media ${Breakpoints.tablet} {
    white-space: wrap;
    overflow-x: auto;

    display: grid;
    grid-column-gap: 60px;
    grid-template-columns: 1fr 1fr;

    max-width: 1260px;
    margin: 120px auto;

    > a {
      margin: 30px auto;
    }
  }
`;

function combineSetPrice(variants) {
  return `${variants.reduce(
    (acc, variant) => acc + parseFloat(variant.individual.price),
    0
  )}.00`;
}

export default function ProductRecommendations({ products = [] }) {
  const { dispatch } = useContext(store);

  function onBuy(product, isSubscription) {
    let item = {
      name: product.name,
      selectedVariant: product.variants[0],
    };

    if (isSubscription) {
      let cadence;
      getProductSubscriptionData(product).then(data => {
        //look for the option with delivery every 3 if not, get the first one.
        cadence = data?.selling_plan_groups[0]?.selling_plans?.find(option => option.deliveryCadenceCount === 3) || data?.selling_plan_groups[0]?.selling_plans[0];
        if (cadence) {
          dispatch(addSubscriptionItem(item, 1, cadence.deliveryCadenceCount, true, null, cadence.sellingPlanId));
        }
        else { dispatch(addOneTimeItem(item, 1, true)); }
      }).catch(err => {
        console.log(err);
        dispatch(addOneTimeItem(item, 1, true));
      })
    } else {
      dispatch(addOneTimeItem(item, 1, true));
    }
  }

  return (
    <Wrapper>
      <Header2>You might also like</Header2>
      <SliderAndGrid>
        {products.map((product) => (
          product.__typename === "ContentfulProduct"
            ? (
              <ProductCard
                name={product.name}
                slug={product.slug}
                price={product.variants[0].individual.price}
                volumeOrSize={product.variants[0].volumeOrSize}
                description={product.shortDescription?.shortDescription}
                image={product.productImage?.fluid}
                hoverImage={product.useImage?.fluid}
                onBuy={() => onBuy(product, false)}
                onSubscribe={() => onBuy(product, true)}
              />
            )
            : (
              <ProductCard
                name={product.name}
                slug={product.slug}
                price={
                  !product.setItem
                    ? combineSetPrice(product.variants)
                    : product.setItem.price
                }
                description={product.shortDescription?.shortDescription}
                image={product.productImage?.fluid}
                hoverImage={product.hoverImage?.fluid}
              // onBuy={() => onBuy(product, false)}
              // onSubscribe={product.subscription && (() => onBuy(product, true))}
              />
            )
        ))}
      </SliderAndGrid>
    </Wrapper>
  );
}
